import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames'

export default class MinMaxBtns extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    onExpand: PropTypes.func,
    onPin: PropTypes.func,
    onMinus: PropTypes.func,
    onGraph: PropTypes.func,
    expanded: PropTypes.bool,
    pinned: PropTypes.bool
  }

  render() {
    const { onGraph, pinned, expanded, id, onExpand, onPin, onMinus, children, onUp, onDown } = this.props
    const expandable = []
    if (onExpand) {
      expandable.push(
        <a
          tabIndex="-1"
          className="expand-icon"
          title={expanded ? "collapse widget" : "expand widget" }
          key={'exp'}
          onClick={onExpand}
        />
      )
    }
    if (children) {
      expandable.push(children)
    }
    if (onUp) {
      expandable.push(
        <a
          tabIndex="-1"
          className="glyphicon chevron-up"
          title="Move widget ahead"
          key={'up'}
          onClick={onUp}
        />
      )
    }
    if (onDown) {
      expandable.push(
        <a
          tabIndex="-1"
          className="glyphicon chevron-down"
          title="Move widget back"
          key={'down'}
          onClick={onDown}
        />
      )
    }
    if (onPin) {
      expandable.push(
        <a
          tabIndex="-1"
          className={classNames(
              "pin glyphicon glyphicon-pushpin",
              {
                pinned
              }
          )}
          key={'pin'}
          onClick={onPin}
        />
      )
    }
    return (
      <div className="buttons-wrap component-min-max-btns">
        <div className="buttons-rounded">
          {expandable}
        </div>
      </div>
    )
  }
}

MinMaxBtns.displayName = 'MinMaxBtns'